<div class="panel cumulatief">
	<div class="panel-header">
		<div class="column title">
			<h2>Aanwezigheidspiramide</h2>
			<div class="subtitle">{{ subtitleTotaal() }}</div>
		</div>
		<div class="column" data-princexml-ignore data-html2canvas-ignore>
			<app-icon name="info" color="primary-1" hoverColor="primary-2" size="small" [appTooltip]="totaalTooltip"></app-icon>
		</div>
	</div>
	<ng-template #totaalTooltip>
		<div class="tooltip">
			<h4>Aanwezigheidspiramide</h4>
			<p>
				Toont de verdeling van leerlingen over drie interventielagen van het piramideraamwerk (MD-MTSS-model) op basis van hun cumulatieve
				aanwezigheidspercentages binnen het gekozen schooljaar t/m de vorige maand.
			</p>
			<ol>
				@for (laag of interventielagen; track laag) {
					<li>{{ laag }}: {{ interventielaagDetails[laag] }}</li>
				}
			</ol>
		</div>
	</ng-template>
	<div class="panel-content">
		@if (totaalLagen().length > 0) {
			<app-vbar-series
				[partitions]="totaalPartitions()"
				[style]="Style.PLANE"
				[barHeight]="425"
				[barWidth]="136"
				[paddingTop]="0"
				[paddingBottom]="0"
				textAlign="middle"
			></app-vbar-series>
			<div class="panel-details">
				@for (laag of totaalLagen(); track last(laag)!.k) {
					<div (click)="navigateToTotaalLaag(laag)">
						<div class="details-info">
							<div class="details-category">
								<div class="laag-indicator" [class]="generateCssClassForString(last(laag)!.k)"></div>
								{{ displayService.display(last(laag)!.k) }}
							</div>
							<div class="details-stats">{{ getAantalText(laag) }}</div>
						</div>
					</div>
				}
			</div>
		} @else {
			<div>De huidige selectie levert geen resultaten op.</div>
		}
	</div>
</div>
